export enum ReflectionStatusEnum {
  Normal = 'normal',
  Archived = 'archived',
}
